import { useState, useEffect } from 'react';

function GetWindowDimensions() {
    const width = window.innerWidth
    const height = window.innerHeight
    return {
        width,
        height
    };
}

export default function UseWindowDimensions() {
    const [windowDimensions, setWindowDimensions] = useState(GetWindowDimensions());
    useEffect(() => {
        function handleResize() {
            setWindowDimensions(GetWindowDimensions());
        }
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return windowDimensions;
}